import { QRFC } from "./QRFC";
import { Globals } from "./Globals";

export class QUpdatePlanSettings extends QRFC {
  constructor() {
    super();
  }

  InitUpdatePlanSettings(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);
  }

  GetCallName() {
    return "qupdateplansettings";
  }

  SetParams(orgName, user, chartID, payload) {
    this.AddEncodedParameter("org", orgName);
    this.AddEncodedParameter("user", user);
    this.AddEncodedParameter("chartID", chartID);
    this.AddEncodedParameter("data", payload);
  }

  DoTransactionComplete(response, callBackObj) {
    const resp = this.SafeParseResponse(response);
    const success = resp?.success ?? false;

    callBackObj.HandleResponse(success, resp);
  }
}
